import React from "react";
import { Checkbox, TableCell, TableRow } from "@mui/material";

const AddAdminTableRow = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  //   handleNavigateToDetails,
}) => {
  return (
    <TableRow
      hover
      // onClick={(event) => handleClickRow(event, row.id)}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 30,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        padding="checkbox"
        style={{ background: "#fff" }}
        onClick={(event) => handleClickRow(event, row.id)}
      >
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>
      <TableCell
        // component="th"
        id={labelId}
        scope="row"
        padding="none"
        // onClick={handleNavigateToDetails}
        style={tableTitleFieldStyles}
      >
        {row.firstName}
      </TableCell>
      <TableCell padding="none" align="left" style={tableCellStyles}>
        {row.lastName}
      </TableCell>
      <TableCell padding="none" align="left" style={tableCellStyles}>
        {row.userName}
      </TableCell>
      <TableCell padding="none" align="left" style={tableCellStyles}>
        {row.role}
      </TableCell>
    </TableRow>
  );
};

export default AddAdminTableRow;

const tableTitleFieldStyles = {
  border: "1px solid #BABABA",
  // paddingLeft: 5,
  color: "#00A7CD",
  fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
  height: 30,
  paddingLeft: 10,
};

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
  height: 30,
  paddingLeft: 10,
};
// const tableStatusCellStyles = {
//   border: "1px solid #BABABA",
//   cursor: "pointer",
//   fontWeight: 600,
// };
